import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { ContactInfo } from '../types';

interface ContactInfoSectionProps {
  contactInfo: ContactInfo;
}

export const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  contactInfo,
}) => {
  const translations = useSelector(selectTranslations);
  return (
    <Wrapper>
      <InfoRow>
        <Label>{translations?.['b2b.txt.fullNameLabel'] || 'Họ và tên'}:</Label>
        <Value>{contactInfo.fullName}</Value>
      </InfoRow>

      <InfoRow>
        <Label>{translations?.['b2b.txt.contactEmail'] || 'Email liên hệ'}:</Label>
        <Value>{contactInfo.email}</Value>
      </InfoRow>

      <InfoRow>
        <Label>{translations?.['b2b.txt.phoneLabel'] || 'Số điện thoại'}:</Label>
        <Value>
          ({contactInfo.phoneCode}) {contactInfo.phoneNumber}
        </Value>
      </InfoRow>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
`;

const InfoRow = styled.div`
  display: flex;
  gap: 12px;
`;

const Label = styled.span`
  font-size: 14px;
  color: #666;
  min-width: 150px;
`;

const Value = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;
